import loader from "@monaco-editor/loader";

// 配置使用本地路径,避免CDN
loader.config({
  paths: {
    vs: "/monaco-editor/vs",
  },
});

export default loader;
